import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import LinkedIn from "../../images/ikoner/linkedin.svg"
import Email from "../../images/ikoner/email.svg"

import "./authorcard.scss"

const AuthorCard = ({ author, by }) => {
  const authorImages = useStaticQuery(graphql`{
  allFile(
    filter: {relativeDirectory: {eq: "author"}, extension: {regex: "/(jpg)|(png)|(jpeg)/"}}
    sort: {base: DESC}
  ) {
    edges {
      node {
        base
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [WEBP], width: 400, quality: 100)
        }
      }
    }
  }
}`)

  const transformImage = authorImages.allFile.edges.find(element => element.node.base === (author + ".jpg"));
  const authorImage = getImage(transformImage.node.childImageSharp.gatsbyImageData);

  return (
    <div className="author-card">
      {author === "andreas" ? (
        <div className="author-card-content">
          <div className="profile">
            <GatsbyImage image={authorImage} alt="Andreas Sjölander" />
          </div>
          <div className="bio">
            {!by && <div className="by">Innehållsansvarig</div>}
            <Link className="author-name" to="/om-oss/andreas-sjolander/">Andreas Sjölander</Link>
            <div className="expertise">Skribent & Casinoexpert</div>

            <div className="contact">
              <a href="https://se.linkedin.com/in/andreas-sj%C3%B6lander-0a069421b" target="_blank" rel="noopener noreferrer">
                <img src={LinkedIn} width="24" height="24" alt="LinkedIn" className="linkedin" />
              </a>

              <a href="mailto:info@alcasino.se">
                <img src={Email} width="24" height="24" alt="Email" className="email" />
              </a>
            </div>

            <p className="description">Med många och värdefulla år inom spelbranchen hjälper Andreas våra läsare att utvidga sina kunskaper om casinon och spel på nätet. Han är vår "content-kung" och casinoexpert.</p>
          </div>
        </div>
      ) : (
        <div className="author-card-content">
          <div className="profile">
            <GatsbyImage image={authorImage} alt="Kestutis Balcius" />
          </div>
          <div className="bio">
            {!by && <div className="by">Innehållsansvarig</div>}
            <Link className="author-name" to="/om-oss/kestutis-balcius/">Kestutis Balcius</Link>
            <div className="expertise">Skribent & Webbansvarig</div>

            <div className="contact">
              <a href="https://se.linkedin.com/in/kestutis-balcius-00999710b" target="_blank" rel="noopener noreferrer">
                <img src={LinkedIn} width="24" height="24" alt="LinkedIn" className="linkedin" />
              </a>
              <a href="mailto:info@alcasino.se">
                <img src={Email} width="24" height="24" alt="Email" className="email" />
              </a>
            </div>

            <p className="description">Kestutis har lång erfarenhet inom casino och betting från sitt arbete på spelbolag både utomlands och i hemlandet Sverige. Nu delar han generöst med sig av sin expertis med våra läsare på Alcasino.</p>
          </div>
        </div>
      )}

    </div>
  )
}

export default AuthorCard